import { render, staticRenderFns } from "./done.vue?vue&type=template&id=519bce6c&"
import script from "./done.vue?vue&type=script&lang=ts&"
export * from "./done.vue?vue&type=script&lang=ts&"
import style0 from "./done.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports